import { NoticesHelper } from "../BotUserProfile/types";
import PaymentSystemsCore from './CashRegisters'
import { Notice, PayStatus } from './Notices/types'
import { Report } from './ProductReports/types'
import ProductsCore from './Products'

export type ShopConfig = {
  paymentSystemsCore: PaymentSystemsCore
  productsCore: ProductsCore
  getPreview: (image: string) => string
	removeNotice: (id: number) => Promise<void>
  getReports: () => Promise<Array<Report>>
  exportTables: {
    cashRegisters: () => void
    products: () => void
    sales: () => void
  },
} & Pick<NoticesHelper, 'refundPayment' | 'getNotices'>

export enum Pages {
	Products,
  CashRegisters,
	Notices,
	ProductReports,
}
